import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';

// This is a legacy banner working off the catch-all hasPricingAndPurchasingFailed selector
// It surfaces generic language if any of the several things fueling that selector fails
// We are moving towards implementing specific error states in <FallbackErrorBanner/>
const FailedLoadBanner = ({
  hasFailed = false
}) => {
  if (hasFailed) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "FAILED_LOAD_BANNER"
      }), /*#__PURE__*/_jsx(UIAlert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "failedLoadBanner.title"
        }),
        type: "danger",
        className: "m-bottom-4",
        style: {
          width: '100%'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "failedLoadBanner.description"
        })
      })]
    });
  }

  return null;
};

export default FailedLoadBanner;